/*
 * Lib Devtools
 */
class appDevTools extends LibModule {

    DOMReady() {

        // Get the div
        let devTools = $('#dev-tools');

        if (devTools.length !== 1) {
            return;
        }

    }

    afterDOMReady() {
        let devToolsMailpit = Lib.Devtools.getDevToolEl('link-to-mailpit');
        if (devToolsMailpit.length) {
            $(Lib).on('dev-tool.link-to-mailpit.click', () => {
                console.log(devToolsMailpit.data('additionaldata').url);
                Lib.Util.redirect(devToolsMailpit.data('additionaldata').url, false, false, true);
            });
        }

    }

}

Lib.appDevTools = new appDevTools;
